<template>
  <panel-block panel-group id="pn-format">
    <panel-item>
      <label for="prop-format">
        Format
        <property-change-detector
          :left="selectedObjectModelProperty"
          :right="selectedObjectModelProperty.publishedEquivalent"
          :properties="[['format_type', 'type'], ['min_value', 'min'], ['max_value', 'max'], ['decimal_places', 'decimal places']]"
        />
      </label>
      <a-select
        v-model.number="selectedObjectModelProperty.format_type"
        @input="updateFormatAssociatedFields"
        :options="formatTypes"
        id="prop-format"
        compress
        ref="formatTypeSelect"
      ></a-select>
    </panel-item>

    <panel-item v-if="selectedObjectModelProperty.hasPatternFormat">
      <div class="sr-only">
        <label for="formatPattern">Pattern</label>
      </div>
      <input id="formatPattern" type="text" v-model="selectedObjectModelProperty.format_pattern" placeholder="Pattern">
    </panel-item>

    <panel-item v-if="selectedObjectModelProperty.hasFormat">
      <div class="sr-only">
        <label for="format-message-text">Custom Validation Error</label>
      </div>
      <expandable-textarea
        v-model="selectedObjectModelProperty.format_message"
        id="format-message-text"
        placeholder="Custom validation error"
      ></expandable-textarea>
    </panel-item>

    <panel-item v-if="selectedObjectModelProperty.hasNumericFormat || selectedObjectModelProperty.hasCurrencyFormat">
      <min-max-input compress :model="selectedObjectModelProperty"></min-max-input>
    </panel-item>

    <panel-item v-if="selectedObjectModelProperty.hasCurrencyFormat">
      <has-decimal-places-input :model="selectedObjectModelProperty"></has-decimal-places-input>
    </panel-item>

    <panel-item v-if="selectedObjectModelProperty.hasNumericFormat">
      <decimal-count-input :model="selectedObjectModelProperty"></decimal-count-input>
    </panel-item>
  </panel-block>
</template>

<script lang="ts">
  import Vue from "vue";
  import {InputFormatType} from "../../form_builder/models/inputFormatType";
  import {ObjectModelPropertyCapability} from "../../../common/models/objectModelProperties/objectModelPropertyCapability";
  import selectedMixin from "../mixins/selectedMixin";
  import InputFormatDefinition from "../../../common/models/inputFormatDefinition";
  import MinMaxInput from "../../../common/components/minMaxInput.vue";
  import DecimalCountInput from "../../../common/components/decimalCountInput.vue";
  import HasDecimalPlacesInput from "../../../common/components/hasDecimalPlacesInput.vue";
  import {IDefaultVOption} from "../../../common/interfaces/vSelectInterfaces";
  import PropertyChangeDetector from "./property-change-detector.vue"

  export default Vue.extend({
    mixins: [selectedMixin],
    components: {
      MinMaxInput,
      HasDecimalPlacesInput,
      DecimalCountInput,
      PropertyChangeDetector,
    },
    data: function () {
      return {
        InputFormatType,
        ObjectModelPropertyCapability: ObjectModelPropertyCapability,
      };
    },
    methods: {
      updateFormatAssociatedFields(format): void {
        this.selectedObjectModelProperty.updateFormatAssociatedFields(format);
      },
    },
    computed: {
      formatTypes(): IDefaultVOption<InputFormatType>[] {
        if (this.selectedObjectModelProperty.can(ObjectModelPropertyCapability.numericFormattable)) {
          return [
            {label: InputFormatDefinition.getDisplayName(InputFormatType.Numeric), value: InputFormatType.Numeric},
            {label: InputFormatDefinition.getDisplayName(InputFormatType.Currency), value: InputFormatType.Currency},
          ];
        } else {
          return [
            {label: InputFormatDefinition.getDisplayName(InputFormatType.None), value: InputFormatType.None},
            {
              label: InputFormatDefinition.getDisplayName(InputFormatType.Alphanumeric),
              value: InputFormatType.Alphanumeric
            },
            {label: InputFormatDefinition.getDisplayName(InputFormatType.Email), value: InputFormatType.Email},
            {label: InputFormatDefinition.getDisplayName(InputFormatType.Phone), value: InputFormatType.Phone},
            {label: InputFormatDefinition.getDisplayName(InputFormatType.Zip), value: InputFormatType.Zip},
            {label: InputFormatDefinition.getDisplayName(InputFormatType.Url), value: InputFormatType.Url},
            {label: InputFormatDefinition.getDisplayName(InputFormatType.Pattern), value: InputFormatType.Pattern},
            {
              label: InputFormatDefinition.getDisplayName(InputFormatType.SocialSecurity),
              value: InputFormatType.SocialSecurity
            },
          ];
        }
      },
    },
  });
</script>